"use client"

import { useFontLoader } from "@plura/client/hooks";
import { LeadForm } from "@plura/shared/types";
import ConversationWrapper from "../../organisms/ConversationWrapper";
import { resetDefaultValuesToBlank } from "@plura/client/utils";
import { TrpcProvider } from "../../atoms";

const PreviewWrapper = ({ formPreview }: { formPreview: LeadForm }) => {
  const { fontsLoaded } = useFontLoader({
    fontFamily: formPreview?.fontFamilySetting,
  });

  return (
    <TrpcProvider>
      <div className="h-[600px] overflow-hidden rounded-[18px] border border-solid border-[#efefef]">
        <ConversationWrapper
          key={`preview-form`}
          wrapperId="preview-wrapper"
          previewMode={true}
          leadForm={{ ...formPreview, hideBuiltWithBadge: true }}
          fontsLoaded={fontsLoaded}
          currentStepOverride={null}
          defaultValues={resetDefaultValuesToBlank(formPreview.journeyItems ?? [])}
        />
      </div>
    </TrpcProvider>
  )
}
export default PreviewWrapper